import { makeAutoObservable } from 'mobx';

class ErrorStore {
    private messages: string | undefined = undefined;

    constructor() {
        makeAutoObservable(this);
    }

    get message(): string | undefined {
        return this.messages;
    }

    set message(msg: string | undefined) {
        this.messages = msg;
    }
}

export default ErrorStore;
